import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Table from "../../../_common/Table";
import EditCcoModal from "./EditCcoModal";
import ProjAdminCcoDetails from "./CcoDetails";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { docPermConstants } from "../../../../_constants/permissionConstants";
import ccoActions from "../../../../_actions/ccoActions";
import locationActions from "../../../../_actions/locationActions";
import "../styles/projAdmin.css";

class Ccos extends Component {
  state = {
    isNew: false,
    hasLinks: false,
    sortColumn: { path: "ccoNo", order: "asc" },
    descFilter: "",
    selectedCcoId: null,
    showEditCcoModal: false,
  };

  columns = [
    { path: "ccoNo", label: "No." },
    { path: "supplementNo", label: "Supp." },
    { path: "description", label: "Description" },
    {
      path: "paymentMethods",
      label: "Pmt. Methods",
      content: (c) => this.renderPaymentMethods(c.paymentMethods),
    },
  ];

  componentDidMount() {
    const { dispatch, projectId } = this.props;
    dispatch(ccoActions.getAll(projectId));
    dispatch(locationActions.getAll(projectId));
  }

  handleChange_descFilter = (e) => this.setState({ descFilter: e.target.value });

  handleSort = (sortColumn) => this.setState({ sortColumn });

  handleClick_clearFilters = (e) => {
    e.preventDefault();
    this.setState({ descFilter: "" });
  };

  handleClick_ccoTr = (selectedCco) => {
    const { dispatch, projectId } = this.props;
    this.setState({ selectedCcoId: selectedCco.ccoId }, () =>
      dispatch(ccoActions.getDetails(selectedCco.ccoId, projectId))
    );
  };

  handleClick_editCco = (e) => {
    e.preventDefault();
    this.setState({ isNew: false }, this.toggleEditCcoModal);
  };

  handleClick_addCco = (e) => {
    e.preventDefault();
    this.setState({
      isNew: true,
      selectedCcoId: 0,
      showEditCcoModal: true,
    });
  };

  deleteCallback = () => this.setState({ selectedCcoId: null });

  getData = () => {
    const { projCcoList } = this.props;
    const { descFilter, sortColumn } = this.state;

    const filteredByDesc =
      descFilter !== null
        ? (projCcoList || []).filter((c) =>
            c.description.toLowerCase().includes(descFilter.trim().toLowerCase())
          )
        : projCcoList || [];
    return _.orderBy(filteredByDesc, [sortColumn.path], [sortColumn.order]);
  };

  toggleEditCcoModal = () =>
    this.setState({
      showEditCcoModal: !this.state.showEditCcoModal,
    });

  renderPaymentMethods = (pmtMethods) => {
    if (!pmtMethods) return;
    const ccosSplit = pmtMethods.split(",");
    return ccosSplit.length > 0 ? (
      ccosSplit.map((c) => (
        <span key={`pmtMethodKey_${c}`} className="span-bubble p-1 bg-info mr-1">
          {c}
        </span>
      ))
    ) : (
      <span key={`pmtMethodKey_none`} className="span-bubble p-1 bg-info">
        (none)
      </span>
    );
  };

  renderTableFilters = () => {
    const { descFilter } = this.state;
    const { permissions } = this.props;
    return (
      <div className="d-flex flex-row flex-wrap pa-filter-group w-100 mb-1">
        <div className="pa-filter-item pa-filter-item__input flex-grow-1">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <FontAwesomeIcon icon="search" className="fa-fw text-muted" />
              </span>
            </div>
            <input
              name="descFilter"
              id="descFilter"
              className="form-control mr-2"
              value={descFilter}
              onChange={this.handleChange_descFilter}
              placeholder="No/Desc"
            />
          </div>
        </div>
        <div className="pa-filter-item pa-filter-item__btn">
          <button
            type="button"
            name="addCco"
            id="addCco"
            className="btn btn-info"
            onClick={this.handleClick_addCco}
            disabled={!permissions.includes(docPermConstants.EDIT_LEVEL_2)}
          >
            <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
            Add...
          </button>
        </div>
      </div>
    );
  };

  render() {
    const { projectId, permissions } = this.props;
    const { selectedCcoId, showEditCcoModal, isNew, hasLinks, sortColumn } = this.state;
    const data = this.getData();
    return (
      <React.Fragment>
        <div className="d-flex flex-row p-2 w-100">
          <div className="pa-list">
            {this.renderTableFilters()}
            <div className="pa-list__table--wrapper border">
              <Table
                className="table table-sm table-hover pa-list__table"
                data={data}
                columns={this.columns}
                idPropName="ccoId"
                selectedItemId={selectedCcoId && selectedCcoId}
                sortColumn={sortColumn}
                onSort={this.handleSort}
                handleClick_tr={this.handleClick_ccoTr}
              />
            </div>
          </div>
          <div className="pa-details">
            <div className="card">
              <div className="card-header bg-lightgray">CCO Details</div>
              <div className="card-body p-3">
                <ProjAdminCcoDetails
                  permissions={permissions}
                  projectId={projectId}
                  ccoId={selectedCcoId}
                  handleClick_editCco={this.handleClick_editCco}
                  deleteCallback={this.deleteCallback}
                  hasLinks={hasLinks}
                />
              </div>
            </div>
          </div>
          {showEditCcoModal && (
            <EditCcoModal
              projectId={projectId}
              ccoId={selectedCcoId}
              showEditCcoModal={showEditCcoModal}
              toggleEditCcoModal={this.toggleEditCcoModal}
              isNew={isNew}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  projCcoList: state.ccos.projCcoLists[ownProps.projectId] || null,
  projLocationList: state.locations.projLocationLists[ownProps.projectId] || null,
});

export default connect(mapStateToProps)(Ccos);
